export default {
  prescriptionList: {
    search: {
      formulaCategory: '大类',
      productModel: '规格型号',
      figureType: '花纹',
      basicUnit: '基本单位',
      weight: '重量',
      formulaUsage: '配方用途',
      productName: '销售商品',
      productCode: '商品编码',
      materialDesc: '配料描述',
      statusFlag: '配方状态',
      formulaNo: '配方编号',
    },
    label: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门名',
      companyName: '公司名',
      formulaCategory: '大类',
      productModel: '规格型号',
      figureType: '花纹',
      basicUnit: '基本单位',
      weight: '重量',
      formulaUsage: '配方用途',
      productSpec: '规格型号',
      productBrand: '品牌',
      qita: '其他',
      formulaNo: '配方编号',
      productName: '销售商品',
      productCode: '商品编码',
      materialDesc: '配料描述',
      statusFlag: '配方状态',
      auxiliaryMaterialCost: '辅料成本(不含税)(元/kg)',
      rawMaterialCost: '主原料成本(不含税)(元/kg)',
      processCost: '加工费用(不含税)(元/kg)',
      singleCost: '单条成本(元)',
      unit: '元/KG',
      redBack: '红冲退回',
    },
    form: {
      basicDetailInfo: '基本信息',
      basicDetailPct: '配方行项目',
      salesSpecification: '销售规格',
      constructionSpecification: '施工规格',
      costingCost: '成本计算',
    },
    table: {
      sortNo: '行项目号',
      productName: '销售商品',
      materialCategory: '配料类别',
      materialDesc: '配料描述',
      formulaCategory: '大类',
      productModel: '规格型号',
      figureType: '花纹',
      formulaNo: '配方编号',
      productCode: '原料编码',
      materialProductName: '原料名称',
      basicUnit: '基本单位',
      statusFlag: '配方状态',
      weight: '重量',
      selectPlaceholder: '请选择',
      materialNumber: '数量(1/基本单位)',
      addedDate: '添加日期',
      materialPrice: '价格',
      accessories: '辅料',
      ton: '吨',
      gram: '克',
    },
    buttons: {
      error: 'Operation failed!',
      confirm: 'Confirm',
      save: '保存',
      submit: '提交',
      revert: '撤销',
      upload: '上传附件',
      add: '增加',
      delete: '删除',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expand_apply: '数据已存在，是否扩展申请',
      return_list_page: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enable_to_forbid: '启用只针对已禁用的状态',
      forbid_to_enable: '禁用只针对已生效的状态',
      delete_to_enable: '删除只针对非生效的状态',
      merge_need_enable: '合并功能针对已生效的数据',
      saveSuccess: '保存成功',
      periodMoreThenOne: '关联账期数量大于1不可撤销',
    },
    placeholder: {
      productClass: '商品/原料',
      productCode: '产品编号',
      productName: '产品名称',
      productType: '主料/辅料',
      productCategory: '产品类别',
      productConfirmName: '校准名称',
      productStatus: '数据状态',
      projectCode: '项目编号',
      projectName: '项目名称',
      costType: '成本类型',
      companyCode: '公司编号',
      companyName: '公司名',
      confimProductNameSpec: '校准名称（型号）',
      departmentName: '部门名',
      gmtCreate: '创建时间',
      createBy: '创建人',
      productSpec: '规格型号',
      relateOut: '外部关联',
    },
    placeholderTable: {
      productClass: '商品/原料',
      materialCategory: '请输入配料类别',
      productName: '请输入配料描述',
      materialNumber: '请输入数量',
      basicUnit: '请输入基本单位',
      addedDate: '请输入添加日期',
      materialPrice: '请输入价格',
    },
    pages: {
      prescriptionDataAdd: '产品主数据新增',
      prescriptionDataList: '产品主数据',
    },
    title: {
      details: '详细情况',
      productName: '销售商品明细',
      materialDesc: '配料描述明细',
    },
  },
};
